/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DisputeDto } from '../models/dispute-dto';
import { DisputeOrderBy } from '../models/dispute-order-by';
import { DisputeTypeEnum } from '../models/dispute-type-enum';
import { OrderDirectionEnum } from '../models/order-direction-enum';
import { PagedDataDtoOfDisputeDto } from '../models/paged-data-dto-of-dispute-dto';
import { ProcessorEnum } from '../models/processor-enum';


/**
 * Provides an information about the disputes
 */
@Injectable({
  providedIn: 'root',
})
export class DisputesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation disputesSearch
   */
  static readonly DisputesSearchPath = '/v1/payments/disputes';

  /**
   * Permissions: core.disputes.get
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disputesSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  disputesSearch$Response(params?: {
    OrderBy?: DisputeOrderBy;
    CaseNumber?: string;
    Mid?: string;
    Processor?: ProcessorEnum;
    DisputeType?: DisputeTypeEnum;
    PaymentToken?: string;
    PublicTransactionId?: string;
    CurrentStatus?: string;
    DisputeAmount?: number;
    StatusDateStartUtc?: string;
    StatusDateEndUtc?: string;
    RaiseDateStartUtc?: string;
    RaiseDateEndUtc?: string;
    DueDateStartUtc?: string;
    DueDateEndUtc?: string;
    DisputeOutcome?: string;
    StartDate?: string;
    EndDate?: string;
    OrderDirection?: OrderDirectionEnum;
    'Pager.PageSize'?: number;
    'Pager.PageIndex'?: number;
  }): Observable<StrictHttpResponse<PagedDataDtoOfDisputeDto>> {

    const rb = new RequestBuilder(this.rootUrl, DisputesService.DisputesSearchPath, 'get');
    if (params) {
      rb.query('OrderBy', params.OrderBy, {});
      rb.query('CaseNumber', params.CaseNumber, {});
      rb.query('Mid', params.Mid, {});
      rb.query('Processor', params.Processor, {});
      rb.query('DisputeType', params.DisputeType, {});
      rb.query('PaymentToken', params.PaymentToken, {});
      rb.query('PublicTransactionId', params.PublicTransactionId, {});
      rb.query('CurrentStatus', params.CurrentStatus, {});
      rb.query('DisputeAmount', params.DisputeAmount, {});
      rb.query('StatusDateStartUtc', params.StatusDateStartUtc, {});
      rb.query('StatusDateEndUtc', params.StatusDateEndUtc, {});
      rb.query('RaiseDateStartUtc', params.RaiseDateStartUtc, {});
      rb.query('RaiseDateEndUtc', params.RaiseDateEndUtc, {});
      rb.query('DueDateStartUtc', params.DueDateStartUtc, {});
      rb.query('DueDateEndUtc', params.DueDateEndUtc, {});
      rb.query('DisputeOutcome', params.DisputeOutcome, {});
      rb.query('StartDate', params.StartDate, {});
      rb.query('EndDate', params.EndDate, {});
      rb.query('OrderDirection', params.OrderDirection, {});
      rb.query('Pager.PageSize', params['Pager.PageSize'], {});
      rb.query('Pager.PageIndex', params['Pager.PageIndex'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedDataDtoOfDisputeDto>;
      })
    );
  }

  /**
   * Permissions: core.disputes.get
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `disputesSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disputesSearch(params?: {
    OrderBy?: DisputeOrderBy;
    CaseNumber?: string;
    Mid?: string;
    Processor?: ProcessorEnum;
    DisputeType?: DisputeTypeEnum;
    PaymentToken?: string;
    PublicTransactionId?: string;
    CurrentStatus?: string;
    DisputeAmount?: number;
    StatusDateStartUtc?: string;
    StatusDateEndUtc?: string;
    RaiseDateStartUtc?: string;
    RaiseDateEndUtc?: string;
    DueDateStartUtc?: string;
    DueDateEndUtc?: string;
    DisputeOutcome?: string;
    StartDate?: string;
    EndDate?: string;
    OrderDirection?: OrderDirectionEnum;
    'Pager.PageSize'?: number;
    'Pager.PageIndex'?: number;
  }): Observable<PagedDataDtoOfDisputeDto> {

    return this.disputesSearch$Response(params).pipe(
      map((r: StrictHttpResponse<PagedDataDtoOfDisputeDto>) => r.body as PagedDataDtoOfDisputeDto)
    );
  }

  /**
   * Path part for operation disputesGet
   */
  static readonly DisputesGetPath = '/v1/payments/disputes/{token}';

  /**
   * Permissions: core.disputes.get
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disputesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  disputesGet$Response(params: {
    token: string;
  }): Observable<StrictHttpResponse<DisputeDto>> {

    const rb = new RequestBuilder(this.rootUrl, DisputesService.DisputesGetPath, 'get');
    if (params) {
      rb.path('token', params.token, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DisputeDto>;
      })
    );
  }

  /**
   * Permissions: core.disputes.get
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `disputesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disputesGet(params: {
    token: string;
  }): Observable<DisputeDto> {

    return this.disputesGet$Response(params).pipe(
      map((r: StrictHttpResponse<DisputeDto>) => r.body as DisputeDto)
    );
  }

}
